import React from "react"
import { Button } from "antd"

const FooterComponents = (props) => {
  const { onResetForm, disabled, isLoadingSave } = props
  const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
      const combinedStyle = {
        ...(hasFreshchat ? { marginRight: "65px" } : {}),
      }
  return (
    <div className="container-footer-form">
      <div className="group-buttons" style={combinedStyle}>
        <div>
          <Button onClick={() => onResetForm()}>Cancelar</Button>
        </div>
        <div>
          <Button
            type="primary"
            loading={isLoadingSave}
            htmlType="submit"
            disabled={disabled}>
            Guardar
          </Button>
        </div>
      </div>
    </div>
  )
}

FooterComponents.propTypes = {}

export default FooterComponents
